// @vendors
import { useEffect, useState, useContext } from "react"
import { Button, Form, Modal, Collapse } from "antd"
import cx from 'classnames'
import { useParams, useHistory } from 'react-router-dom';
import Context from '../../context/appContext';
import {
    getUrl, getBody, replaceAtrBody, encrypt, decrypt, getInfoField, getSidebarData, validateDiff, getDate, validateIsBefore, filterObject, getNewObject, newKeySituations
} from '../../utils/utils';
import { fields } from "constants/fieldTypes";
import { RichText } from 'prismic-reactjs'
import { Helmet } from "react-helmet";
import jwt_decode from "jwt-decode";
import moment from 'moment';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// @components
import SidebarResume from "components/fields/sidebar-resume";

// @hooks
import usePrismicByUID from "hooks/usePrismicByUID";

// @styles
import 'react-multi-carousel/lib/styles.css';
import NotifyError from "components/notification-error";
import Homepage from "components/homepage";
import ModalInfo from "components/modal-info";
import QuoteNumberTitle from "components/quote-title";
import Loading from "components/loading";
import ModalLoad from "components/modal-loading";
import ModalWarning from "components/modal-warning";
import { Bounce } from "react-reveal";
import { current } from "__test__/components/fields/checkbox/data.mock";

export const agentEmailKey = 'correoAgente';
export const agentKey = 'agente';
export default function Quotation() {
    let [costoInicial, setCostoInicial] = useState(null); 
    let [costoPolicy,setCostoPolicy] = useState(null);
    let history = useHistory();
    let { token } = useParams();
    const { info } = usePrismicByUID('flujo_cotizacion_v2');
    const [loading, setLoading] = useState(false);
    const [loadBtn, setLoadBtn] = useState(false);
    const [isRedirect, setIsRedirect] = useState(false);
    const [isPaymentRedirect, setIsPaymentRedirect] = useState(false);
    const [showFinalModal, setShowFinalModal] = useState(false);
    const [tokenDecoded, setTokenDecoded] = useState(false);
    const [persistenceModel, setPersistenceModel] = useState({});
    const [numSequence, setNumSequence] = useState();
    const [modalInfo, setModalInfo] = useState();
    const [modalWarning, setModalWarning] = useState({});
    const [notificationError, setNotificationError] = useState({ visible: false, title: "", description: "" });
    const [form] = Form.useForm();
    const [emailAgent, setEmailAgent] = useState();

    const { product, customRequest, dataForm: { data, formResponses, hiddenFields, disabledFields }, folio, setFolio,
        formStatus: { steps, currentStep, currentQuestion, numberQuestionsStep, isGoToBack }, isClassActive, returnButton,
        disabledButtonContinue, tokenInfo, responseRequest, isSendForm, progressStep, homePageData, showHomePage, showAlert, isActive,
        setDataForm, setFormStatus, setReturnButton, setIsClassActive, setIsActive, setSidebarData, setFormValues, setTokenInfo, insureds, loadingComponent, validateRFC, setIsSendForm,
        setProgressStep, setPriceToShow, setPolicyNumber, setInsureds, setHomePageData, setShowHomePage, setLoadingProcedure, setResponsesRequest, setCleanFields
    } = useContext(Context);

    const mapSteps = (stepsLcl, dataLcl, dataFormLcl) => {
        const fullSteps = stepsLcl
            .map(({ key_step, name, buttonnext, returnbutton, sidebar }) => ({ key_step, name, buttonnext, returnbutton, sidebar, questions: [] }))

        const stepsIndex = {}
        fullSteps.forEach(({ key_step }, index) => {
            stepsIndex[key_step] = index
        })

        dataLcl.forEach(({ primary, items, ...rest }) => {
            const currentStepIndex = stepsIndex[primary.associated_group]
            let newItems = [];

            const stepsParentGroup = dataFormLcl && dataFormLcl.find((value) => value.title === primary.associated_group);
            items.forEach((item) => {
                const itemField = item && item.fieldkey === 'fakeField' ? { type: item.fieldkey } :
                    stepsParentGroup && stepsParentGroup.components.find((field) => field.key === item.fieldkey);
                newItems.push(itemField);
            });

            if (fullSteps[currentStepIndex]) {
                fullSteps[currentStepIndex].questions = [
                    ...fullSteps[currentStepIndex].questions,
                    {
                        primary,
                        newItems,
                        ...rest
                    }
                ]
            }
        })
        return fullSteps
    }

    const getValidate = (decode) =>{
        let validate = true
        if (numSequence) {
         Object.values(newKeySituations[2]).forEach((person)=>{
            if(tokenInfo[person]!==decode[person]){
                validate = false
            }
         });
        }  
        return validate
    }

    const getUserInfo = (value) => {
        let decode = jwt_decode(value);
        if (decode && !decode.ramoId) {
            const productValues = JSON.parse(process.env.REACT_APP_CHANNEL_VALUES_DIRECT);
            decode['ramoId'] = productValues.ramo;
        }
        setTokenInfo(getValidate(decode)?decode:tokenInfo);
        setTokenDecoded(true);
    }

    useEffect(() => {
        if (costoInicial !== null) {
          setCostoPolicy(costoInicial);
        }
      }, [costoInicial]);   
       
                
    useEffect(() => {
        const localToken = localStorage.getItem(`localToken_${product}`);
        if (token && token.length > 0) {
            const tokenDecode = jwt_decode(token);
            if (tokenDecode && tokenDecode.origen === 'externo' || tokenDecode.origen === 'pasarela') {
                setIsPaymentRedirect(tokenDecode.origen === 'pasarela');
                const dataDecrypt = decrypt(tokenDecode.value, process.env.REACT_APP_RECOTIZADORES_KEY);
                const tokenData = dataDecrypt && dataDecrypt.length > 0 && JSON.parse(dataDecrypt);
                history.replace(`/${product}/`);
                setLoadingProcedure(true);
                const dataObject = {
                    oficina: tokenData.oficinaId,
                    ramoId: tokenData.ramoId,
                    userId: tokenData.usuarioId,
                    email: tokenData.email,
                    id: tokenData.cotizacionId,
                    origen: tokenDecode.origen,
                    isCallCenter: tokenDecode.isCallCenter
                }
                setTimeout(() => { setNumSequence(dataObject) }, 10000);

                if(tokenData?.usuarioId ){
                    const { email } = tokenData;
                    setEmailAgent(email);
                }

            } else {
                localStorage.setItem(`localToken_${product}`, JSON.stringify(token));
                getUserInfo(token);
            }
        } else if (localToken && !tokenInfo.usuarioId) {
            getUserInfo(JSON.parse(localToken));
        }
        if (tokenInfo && tokenInfo.usuarioId && tokenDecoded) {
            setShowHomePage(false);
            history.replace(`/${product}/`);
            const { email } = tokenInfo;
            setEmailAgent(email);
        }
    }, [token, tokenInfo]);

    useEffect(() => {
        isSendForm && sendForm(); setIsSendForm(false);
    }, [isSendForm])

    useEffect(() => {
        if (responseRequest && Object.keys(responseRequest).length > 0) {
            setPersistenceModel(persistenceModelLcl => ({
                ...persistenceModelLcl, cotizaciones: responseRequest.cotizacion
            }));
            setProgressStep([...progressStep]);
        }
    }, [responseRequest])

    useEffect(() => {
        if (insureds && insureds.length > 0) {
            setPersistenceModel(persistenceModelLcI => ({
                ...persistenceModelLcI, insureds: insureds, insuredsActive: isActive,
            }));
            setProgressStep([...progressStep]);
        }
    }, [insureds])

    useEffect(async () => {
        if (persistenceModel && persistenceModel.componentes && persistenceModel.componentes.length > 0) {
            const copyPersistenceModel = { ...persistenceModel };
            delete copyPersistenceModel._id;
            copyPersistenceModel.configuracion.estadoBarraProgreso = progressStep;
            copyPersistenceModel.configuracion.fechaModificacion = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
            const serviceOptions = JSON.parse(process.env.REACT_APP_INSERT_RESPONSES_SERVICE);
            const url = `${process.env.REACT_APP_BACKEND}${process.env.REACT_APP_PATH}${serviceOptions.url}`;
            await customRequest(url, serviceOptions.headers, serviceOptions.method, copyPersistenceModel);
            setIsRedirect(showFinalModal);
        }
    }, [progressStep])

    useEffect(async () => {
        if (!numSequence && info && data && data.formDefinition) {
            data && data.persistenceModel && setPersistenceModel({ ...data.persistenceModel });
            setHomePageData({ logo: info.data.logo, links: info.data.headermenulinks });
            setPersistenceModel(persistenceModelLcl => (persistenceModelLcl.datosAgente ?
                { ...persistenceModelLcl, datosAgente: tokenInfo } : { ...persistenceModelLcl }));
            setFormStatus({
                steps: mapSteps(info.data.orderbysteps, info.data.body, data.formDefinition.components),
                currentStep,
                currentQuestion,
                numberQuestionsStep
            });
        }
    }, [info, data]);

    useEffect(async () => {
        if (numSequence && info && data && data.formDefinition) {
            setLoadBtn(true);
            const serviceOptions = JSON.parse(process.env.REACT_APP_FIND_RESPONSES_SERVICE);
            const encryptedData = encrypt(JSON.stringify(numSequence), serviceOptions.key);
            const url = `${process.env.REACT_APP_BACKEND}${process.env.REACT_APP_PATH}${serviceOptions.url}?data=${encryptedData}`;
            let message = '';
            const response = await customRequest(url, serviceOptions.headers, serviceOptions.method, {});
            if (response && response.tipo_estado && response.tipo_estado === 'exito' && response.respuesta) {
                if (response.respuesta.configuracion && response.respuesta.configuracion.estadoFlujo === 'Activo') {
                    const responseModel = { ...response.respuesta };
                    delete responseModel._id;
                    const isBefore = validateIsBefore(responseModel).isBefore;
                    if (!isPaymentRedirect && isBefore) {
                        setPersistenceModel(responseModel);
                        setShowFinalModal(true);
                    } else {
                        let responseSteps = responseModel.componentes && responseModel.componentes.length > 0 && responseModel.componentes;
                        const formCurrentStatus = responseModel.configuracion && responseModel.configuracion.ultimaPersistencia;
                        const datosAgente = responseModel.datosAgente;
                        const statusProgressStepLcl = responseModel.configuracion && responseModel.configuracion.estadoBarraProgreso;
                        const insuredsResponse = responseModel.insureds && responseModel.insureds.length > 0 ? responseModel.insureds : [];

                        setCleanFields(isBefore === undefined ? true : isBefore);
                        setInsureds(insuredsResponse);
                        setIsClassActive(responseModel?.coveragesActive);
                        setIsActive(responseModel.insuredsActive ? responseModel.insuredsActive : []);
                        setProgressStep(statusProgressStepLcl);
                        setTokenInfo(datosAgente);
                        setFolio(responseModel.configuracion.folio);
                        setResponsesRequest({ cotizacion: responseModel.cotizaciones ? responseModel.cotizaciones : [] });
                        data && data.persistenceModel && setPersistenceModel(responseModel);

                        if(emailAgent){
                            if(responseSteps.find((e) => e.key === agentEmailKey)) {
                              responseSteps = responseSteps?.map(item => {
                                if (item.key === agentEmailKey) {
                                    return { ...item, value: emailAgent };
                                }
                                return item;
                              }) 
                            }
                            else {
                              responseSteps.push({ key: agentEmailKey, value: emailAgent })
                            }
                        }

                        setDataForm(dataForm => ({ ...dataForm, formResponses: responseSteps }));
                        setSidebarData(getSidebarData(insuredsResponse, responseSteps));
                        if (requote(statusProgressStepLcl, responseModel, responseSteps, datosAgente)) {
                            setFormStatus({
                                steps: getAllSteps(data.formDefinition.components, responseSteps),
                                currentStep: formCurrentStatus.currentStep,
                                currentQuestion: formCurrentStatus.currentQuestion,
                                numberQuestionsStep: formCurrentStatus.numberQuestionsStep
                            });
                        }
                    }
                } else if (response.respuesta.configuracion && response.respuesta.configuracion.estadoFlujo === 'Pendiente') {
                    message = {
                        title: 'En proceso...', type: 'notFoundBank', numSequence: numSequence.id,
                        description: 'Tu pago está siendo procesado por tu banco, este proceso puede demorar hasta 2 días hábiles desde que realizaste el pago. Una vez confirmado el pago recibirás la póliza en tu correo.'
                    }
                } else {
                    message = { type: 'notFoundInfo', description: `Ya ha finalizado el tramite con el folio o número de cotización ${numSequence.id}` };
                }
            } else {
                message = { type: 'notFoundInfo', description: `No existen datos para el tramite con el folio o número de cotización ${numSequence.id}` };
            }

            if (!message) {
                setHomePageData({ ...homePageData, links: null });
                setShowHomePage(false);
            } else {
                setModalWarning({ ...message, visible: true });
            }
            setLoadBtn(false);
            setLoadingProcedure(false);
        }
    }, [numSequence]);

    useEffect(() => {
        showAlert && showAlert.renderMessage && showModal(showAlert)
    }, [showAlert])

    useEffect(() => {
        if (document.getElementsByClassName('question-container').length > 0) {
            document.getElementById('root').classList.add('height-container');
        }
    })

    const requote = async (statusStep, responseModel, responseSteps, datosAgente) => {
        setReturnButton(false);
        setLoading(true);
        let result = true;
        const valStep = statusStep && statusStep.filter(st => (st.key_step === 'step_informacion_asegurados' ||
            st.key_step === 'step_emision_contratante') && st.active);

        if (valStep && valStep.length > 0) {
            result = false;
            const allComponents = data.formDefinition.components;
            const quoteField = getInfoField('coberturas', 'step_cotizacion', allComponents);
            const options = JSON.parse(quoteField.content);
            const body = getBody({}, data.modelConfig, responseSteps, responseModel.insureds, datosAgente, responseModel.coveragesActive);
            const res = await customRequest(options.url, options.headers, options.method, body);
            data['infoRequote'] = { res, infoRequest: options };

            if (res && res.success && res.respuesta.policy) {
                result = true;
                const policy = res.respuesta.policy;
                setPolicyNumber(policy.policy.policyNumber);
                setPriceToShow(policy.costs.amount);
                setModel(policy.policy);
                openFinalModal(valStep, responseModel, statusStep);
            }
        }
        setReturnButton(true);
        setLoading(false);
        return result;
    }

    const openFinalModal = (valStep, responseModel, statusStep) => {
        if (!isPaymentRedirect) {
            const finalStep = valStep.find(y => y.key_step === 'step_emision_contratante');
            const statusPayment = responseModel && responseModel.payment && responseModel.payment.length > 0
                && responseModel.payment[responseModel.payment.length - 1]; //Obtener el último estado del pago
            if (finalStep && finalStep.key_step && statusPayment && (statusPayment.payment.status || statusPayment.status) !== 'canceled') {
                const isUrlPayment = responseModel && responseModel.urlPayment;
                const lastUrl = isUrlPayment && isUrlPayment[isUrlPayment.length - 1];
                setShowFinalModal(lastUrl && lastUrl.validity.length);
            }
        } else if (responseModel && responseModel.urlPayment && responseModel.urlPayment.length > 0) {
            const copyUrlPayment = JSON.parse(JSON.stringify(responseModel.urlPayment));
            copyUrlPayment[copyUrlPayment.length - 1].validity = false;
            setPersistenceModel(persistenceModelRD => ({
                ...persistenceModelRD, urlPayment: copyUrlPayment
            }));
            setProgressStep(statusStep);
        }
    }

    const getAllSteps = (components, responseSteps) => {
        const newComponents = JSON.parse(JSON.stringify(components));
        newComponents && newComponents.forEach((item, index) => {
            item && item.components.forEach((itemComponent, i) => {
                const responseItem = responseSteps && responseSteps.find(x => x.key === itemComponent.key);
                if (responseItem && Object.keys(responseItem).length > 0) {
                    newComponents[index].components[i].value = responseItem.value;
                }
            });
        });
        return mapSteps(info.data.orderbysteps, info.data.body, newComponents);
    }

    useEffect(() => {
        setFormStatus({
            steps,
            currentStep,
            currentQuestion,
            numberQuestionsStep: steps[currentStep]?.questions.length
        });
    }, [steps]);

    const nextStep = async () => {
        validateCallServiceOrExecuteFunction(() => {
            sendRequest({
                steps,
                currentQuestion: 0,
                currentStep: currentStep + 1,
                numberQuestionsStep: steps[currentStep + 1]?.questions.length
            });
        });  
     funcionTagManagerAA(currentStep, currentQuestion)                  
    }; 
        
    const nextStepQuestion = async () => {
        validateCallServiceOrExecuteFunction(() => {
            sendRequest({
                steps,
                currentStep,
                currentQuestion: currentQuestion + 1,
                numberQuestionsStep
            });
        }); 
        funcionTagManagerAA(currentStep, currentQuestion)
                        
    };

    const setAgent = () => emailAgent && !formResponses.find((e) => e.key === agentKey) && formResponses.push({ key: agentKey, value: true}, { key: agentEmailKey, value: emailAgent});
        
 function funcionTagManagerAA(currentStep, currentQuestion){
    setAgent()
    switch(currentStep){
            case 0:
                switch(currentQuestion){
                   case 0:
                     window.dataLayer.push({ 
                    'event' : 'aa_01_datos_pers_1'  
                     });
                   break;
                  case 1:
                    const obtenergenero = persistenceModel.componentes.find(objeto => objeto.key==='genero').value;  
                    window.dataLayer.push({
                      'event' : 'aa_02_genero' ,
                      'genero' : obtenergenero 
                     });
                  break;
                  case 2:
                    const obtenerprotegido = persistenceModel.componentes.find(objeto => objeto.key==='claveTipoAsegurados').value;
                    window.dataLayer.push({ 
                        'event' : 'aa_03_a_quien' ,
                        'protegidos' : obtenerprotegido
                     });
                  break;
                };
            break;
            case 2:
                    switch(currentQuestion){
                    case 0: 
                      window.dataLayer.push({ 
                      'event' : 'aa_04_datos_pers_2' 
                      });
                    break;
                    case 1: 
                    const agenteodirectoA = persistenceModel.datosAgente.name;      
                    const obtenerprotegido1 = persistenceModel.componentes.find(objeto => objeto.key==='claveTipoAsegurados').value; 
                    const obtenergenero1 = persistenceModel.componentes.find(objeto => objeto.key==='genero').value;                     
                    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                    window.dataLayer.push({
                     event: "add_to_cart",
                     ecommerce: {
                     currency: "MXN",
                     value:costoPolicy,
                     items: [
                     {
                      item_id: "Ala_azul", // Incluir SKU que indique el sistema
                      item_name: "Seguro de salud Ala Azul",
                      affiliation: agenteodirectoA, // y SURA Agente cuando es B2B
                      item_brand: "SURA",
                      item_category: "Salud",
                      item_variant: `${obtenerprotegido1}, ${obtenergenero1}, ${isClassActive ? 'SI' : 'NO'}`, 
                      location_id: "ChIJIQBpAG2ahYAR_61",
                      price:  costoPolicy, // Precio varía dependiendo de los  item_variant seleccionados
                      quantity: 1
                    }
                    ]
                  }
                });                                   
                        window.dataLayer.push({ 
                        'event' : 'aa_05_adicionales' ,
                        'proteccion_adicional' : isClassActive ? 'SI':'NO'
                        });                   
                    break;
                };
            break;              
            case 3:
                switch(currentQuestion){
                    case 0:
                    const agenteodirectoA2 = persistenceModel.datosAgente.name;      
                    const obtenerprotegido2 = persistenceModel.componentes.find(objeto => objeto.key==='claveTipoAsegurados').value; 
                    const obtenergenero2 = persistenceModel.componentes.find(objeto => objeto.key==='genero').value;    
                        
                    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                    window.dataLayer.push({
                     event: "add_to_cart",
                     ecommerce: {
                     currency: "MXN",
                     value: costoPolicy,
                     items: [
                     {
                      item_id: "Ala_azul", // Incluir SKU que indique el sistema
                      item_name: "Seguro de salud Ala Azul",
                      affiliation: agenteodirectoA2, // y SURA Agente cuando es B2B
                      item_brand: "SURA",
                      item_category: "Salud",
                      item_variant: `${obtenerprotegido2}, ${obtenergenero2}, ${isClassActive ? 'SI' : 'NO'}`, 
                      location_id: "ChIJIQBpAG2ahYAR_61",
                      price: costoPolicy, // Precio varía dependiendo de los  item_variant seleccionados
                      quantity: 1
                    }
                    ]
                  }
                });               
                        window.dataLayer.push({
                        'event' : 'aa_06_info_asegurados' 
                    });
                    break;       
                };
            break;
    }; 
 };  
       
   
          
    const validateCallServiceOrExecuteFunction = async (callback) => {
        let arrayValidations = [];
        const indexBenef = getCurrentQuestions().newItems.findIndex(val => val.key === 'asegurados');
        if (indexBenef !== -1 && await validateForm()) {
            if (Object.keys(form.getFieldsValue()).length === 0) {
                if (insureds && insureds.length > 1) {
                    const children = insureds.filter(x => x.type !== "T");
                    children.forEach((insured, index) => {
                        const insuredAge = getDate(insured.age);
                        const infoF = getCurrentQuestions().newItems[indexBenef];
                        const dateField = infoF.components.find(x => x.key === "fechaNacimientoAsegurado");
                        arrayValidations[index] = validateDiff(insured.type, dateField, insureds, insuredAge);
                    });
                    if (arrayValidations.find(x => x === true)) {
                        setNotificationError({
                            visible: true,
                            title: "No es posible continuar",
                            description: "Valida la información de los asegurados."
                        });
                    } else {
                        setNotificationError({ visible: false });
                        sendForm();
                        callback();
                    }
                } else {
                    setNotificationError({
                        visible: true,
                        title: "Por favor, agrega al menos un asegurado adicional",
                        description: ""

                    });
                }
            }
        } else if (getCurrentQuestions().newItems.findIndex(val => val.key === 'infoAsegurados') !== -1) {
            if (insureds && insureds.length <= 1) {
                const fieldsValues = filterObject(form.getFieldsValue(), 'Titular');
                const fKey = Object.keys(filterObject(fieldsValues, 'identificador'));
                const insuredId = fKey && fKey[0] && fKey[0].split('-')[1];
                if (await validateForm() && await validateRFC(getNewObject(fieldsValues, 'Titular', insuredId))) {
                    setIsActive({ ...isActive });
                    sendForm();
                    callback();
                }
            } else {
                const keysInsureds = insureds && insureds.map(ik => ik.key);
                const result = keysInsureds && keysInsureds.every((i) => { return isActive[i] === true });
                if (await validateForm() && result) {
                    sendForm();
                    callback();
                }
            }
        } else if (await validateForm()) {
            sendForm();
            callback();
        }
    };

    const sendForm = () => {
        setNotificationError({ visible: false });
        const currentStepValue = steps && steps[currentStep];
        if (currentStepValue && Object.keys(currentStepValue).length > 0) {

            const formStatusValue = isGoToBack ? {
                currentStep: currentStep,
                currentQuestion: currentQuestion < numberQuestionsStep ? currentQuestion : 0,
                numberQuestionsStep: numberQuestionsStep
            } : {
                currentStep: currentQuestion < numberQuestionsStep - 1 ? currentStep : currentStep + 1,
                currentQuestion: currentQuestion < numberQuestionsStep - 1 ? currentQuestion + 1 : 0,
                numberQuestionsStep: numberQuestionsStep
            };

            setPersistenceModel(persistenceModelLcl => ({
                ...persistenceModelLcl, componentes: formResponses,
                coveragesActive: isClassActive,
                configuracion: { ...persistenceModelLcl.configuracion, ultimaPersistencia: formStatusValue }
            }));
        }
    }

    
    const sendRequest = async (setForm) => {
        setLoading(true);
        const valPrimary = steps[currentStep] && steps[currentStep].questions[currentQuestion] && steps[currentStep].questions[currentQuestion].primary;
        const url = getUrl(valPrimary && valPrimary.opciones_servicio ? valPrimary.opciones_servicio : '', formResponses);
        let isShowModalInfo = true;
        if (url) {
            let body = url.method === 'POST' ? getBody(url.body, data.modelConfig, formResponses, insureds, tokenInfo, isClassActive) : {};
            if (body && body.poliza) {
                body.poliza = replaceAtrBody(body.poliza, tokenInfo);
            }

            const isInsert = url.url.includes('insert');
            !isInsert && setReturnButton(false);

            const response = await customRequest(url.url, url.headers, url.method, body);


            if (response && response.success || response.tipo_estado === 'exito' || response.status_type === 'exito') {
                if (response && response.respuesta && response.respuesta.numFolio) {
                    const iFolio = formResponses.findIndex(item => item.key === 'folio');
                    if (iFolio !== -1 && !folio) {
                        const nFolio = response.respuesta.numFolio;
                        formResponses[iFolio].value = nFolio;
                        setFolio(nFolio);
                        const fechaCreacion = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
                        setPersistenceModel(objPersistenceModel => ({
                            ...objPersistenceModel, configuracion: {
                                ...objPersistenceModel.configuracion,
                                folio: nFolio, estadoFlujo: 'Activo', fechaCreacion: fechaCreacion
                            }
                        }));
                    }
                }

                if (response && response.status && !numSequence) {
                    const indexStatus = formResponses.findIndex(item => item.key === 'status');
                    const indexFolio = formResponses.findIndex(item => item.key === 'folio');
                    if (indexStatus != -1) {
                        const value = formResponses[indexStatus].value;
                        formResponses[indexStatus].value = response.status ? response.status : value;
                        const numFolio = data && data.modelFolio.numFolio;
                        formResponses[indexFolio].value = numFolio;
                        const fechaCreacion = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
                        setFolio(numFolio);
                        setPersistenceModel(persistenceModelLcl => (persistenceModelLcl.configuracion ? {
                            ...persistenceModelLcl, configuracion:
                                { ...persistenceModelLcl.configuracion, folio: numFolio, estadoFlujo: 'Activo', fechaCreacion: fechaCreacion }
                        } : { ...persistenceModelLcl }));
                    }
                }
                
                if (response && response.respuesta && response.respuesta.policy) {
                    const policy = response.respuesta.policy; 
                    setCostoInicial(policy.costs.amount);                             
                    setPolicyNumber(policy.policy.policyNumber);
                    setPriceToShow(policy.costs.amount);                    
                    setModel(policy.policy);
                    data['infoRequote'] = { res: response, infoRequest: url };
                              
                }              
                console.log("precio es:", costoPolicy);
                

                setFormStatus(setForm);
            } else {
                isShowModalInfo = (!response || !response.message);
                showModal(response)
            }
            !isInsert && setReturnButton(true);
        } else {
            setFormStatus(setForm);
        }
        isShowModalInfo && showModalInfo();
        setLoading(false);
        
    }

    const setModel = (policy) => {
        if (policy && Object.keys(policy).length > 0) {
            data.modelConfig['polizaCotizacion'] = {
                "oficina": policy.officeId,
                "ramo": policy.productId,
                "estado": "W",
                "poliza": policy.policyNumber,
                "suplemento": 0,
                "rfc": "XXXXXXX"
            };
        }
    }

    const showModalInfo = () => {
        const finalModal = getCurrentQuestions()?.primary.finalmodal;
        if (finalModal) {
            sendForm();
            const dataModalInfo = JSON.parse(finalModal);
            dataModalInfo.visible = true;
            setModalInfo(dataModalInfo);
        }
    }

    const showModal = (response) => {
        const message = response.renderMessage ? response.renderMessage :
            response.message && { renderMessage: { title: "Error", body: response.message } };
        setLoading(false);
        if (response && message) {
            Modal.info({
                icon: '',
                title: message.title,
                className: 'modal-confirm',
                closable: true,
                okButtonProps: {
                    className: 'ant-btn-solid c-2 ant-btn-size-xs'
                },
                okText: 'Aceptar',
                content: <p>{message.body}</p>,
                onOk() { }
            });
        }
    }

    const validateForm = () => {
        return form.validateFields().then(() => {
            return true;
        }).catch(() => { return false })
    }

    const getBtnId = () => {
        const current = getCurrentQuestions();
        const btnId = current && current.primary && current.primary.associated_group ?
            `${current.primary.associated_group}-q${currentQuestion + 1}` : 'btn-q1';
        return btnId;
    }

    const getCurrentQuestions = () => {
        return steps[currentStep] && JSON.parse(JSON.stringify(steps[currentStep].questions[currentQuestion]));
    }

    const handleChange = (valNumSequence) => {
        const channelValues = JSON.parse(process.env.REACT_APP_CHANNEL_VALUES_DIRECT);
        const objectFilters = {
            oficina: channelValues && channelValues.oficina,
            ramoId: channelValues && channelValues.ramo,
            userId: null,
            id: valNumSequence,
            email: process.env.REACT_APP_DEFAULT_EMAIL,
            origen: 'direct'
        };
        valNumSequence && setNumSequence(objectFilters);
        if (!valNumSequence) {
            setHomePageData({ ...homePageData, links: null });
            setShowHomePage(false);
            document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const validateHomePage = () => {
        let showHome = true;
        if (info && info.data) {
            showHome = info.data.showhomepage;
        }
        setShowHomePage(showHome);
        return showHome;
    }

    const continueBtn = () => {
        return steps[currentStep] && steps[currentStep].questions[currentQuestion]
            .primary.buttonnext === "Si" && !(loadingComponent.visible && loadingComponent.active) &&
            (<div className='question-container__actions'>
                <div className='question-container__actions-left' />
                <div className='question-container__actions-right'>
                    {
                        (currentQuestion + 1 === numberQuestionsStep) &&
                        (currentStep + 1 !== steps.length) && (
                            <Bounce delay={8}>
                                <Button
                                    id={getBtnId()}
                                    loading={loading}
                                    className='ant-btn-solid c-3 ant-btn-size-md'
                                    onClick={() => nextStep()}
                                    disabled={disabledButtonContinue}
                                >
                                    <strong>Continuar</strong>
                                </Button>
                            </Bounce>
                        )
                    }
                    {currentQuestion + 1 !== numberQuestionsStep && (
                        <Bounce delay={8}>
                            <Button
                                id={getBtnId()}
                                loading={loading}
                                className='ant-btn-solid c-3 ant-btn-size-md'
                                onClick={() => nextStepQuestion()}
                                disabled={disabledButtonContinue}
                            >
                                <strong>Continuar</strong>
                            </Button>
                        </Bounce>
                    )}
                    {
                        (currentStep === steps.length - 1) &&
                        (currentQuestion + 1 === numberQuestionsStep) && (
                            <Button
                                id={getBtnId()}
                                loading={loading}
                                disabled={disabledButtonContinue}
                                className='ant-btn-solid c-3 ant-btn-size-md'
                                onClick={async () => {
                                    const allData = getBody({}, data.modelConfig, formResponses, [], {}, {});
                                    const personalData = allData && allData.client && allData.client.personalData;
                                    setShowFinalModal(await validateForm() &&
                                        await validateRFC({ ...personalData, type: personalData.personType, birthdate: moment(personalData.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).format('YYYY-MM-DD') }));
                                        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                                        window.dataLayer.push({
                                        event: "add_shipping_info",
                                                  ecommerce: {
                                                 currency: "MXN",
                                                 value: costoPolicy,
                                                 shipping_tier: "Virtual", //Dado que no hay una entrega física (confirmar) podemos dejar el campo de esa manera, y cambiarlo a futuro de ser necesario
                                                   items: [
                                                          {
                                                            item_id: "SKU_12345", // Incluir SKU que indique el sistema
                                                            item_name: "Seguro de salud Ala Azul",
                                                            affiliation: "SURA Directo", // y SURA Agente cuando es B2B
                                                            item_brand: "SURA",
                                                            item_category: "Salud",
                                                            item_variant: "Solo a ti, Femenino, Protección adicional para ti", 
                                                            location_id: "ChIJIQBpAG2ahYAR_61",
                                                            price: costoPolicy, // Precio varía dependiendo de los  item_variant seleccionados
                                                            quantity: 1
                                                         }
                                                         ]
                                                        }
                                         });
                                        
                                        window.dataLayer.push({
                                            'event' : 'aa_07_info_contratante' 
                                        });
                                }}
                            >
                                <strong>Contratar</strong>
                            </Button>
                        )
                    }
                </div>
            </div>)
    }

    return showHomePage && validateHomePage() ? (
        <>
            {modalWarning && modalWarning.visible && <ModalWarning info={modalWarning} setModalWarning={setModalWarning} />}
            <Homepage data={info && info.data && info.data.homepagecontent}
                handleChange={handleChange} loadBtn={loadBtn} />
        </>) :
        info && info.data && (<GoogleReCaptchaProvider reCaptchaKey={info.data.recaptchakey} language="es" >
            <div className='container-xl'>
                <div className='question-container'>
                    <Helmet>
                        <meta charSet="utf-8" />
                    </Helmet>
                    {loadingComponent.visible && loadingComponent.active ? <Loading /> :
                        (<div className='question-container__steps'>
                            {showFinalModal && (<ModalLoad persistenceM={persistenceModel} setPersistenceModel={setPersistenceModel} isRedirect={isRedirect} setIsRedirect={setIsRedirect} />)}
                            {modalInfo && modalInfo.visible && (<ModalInfo info={modalInfo} />)}
                            {notificationError.visible && <NotifyError title={notificationError.title} description={notificationError.description} />}
                            {getCurrentQuestions() && (
                                <Form form={form}
                                    onFieldsChange={setFormValues}
                                    className={
                                        cx(
                                            `question-container__steps-body ${document.getElementsByClassName('sidebar-resume__open').length > 0 && 'column-reverse'}`,
                                            {
                                                'question-container__steps-body-columns-1': steps[currentStep].questions[currentQuestion].primary.columns === '1',
                                                'question-container__steps-body-columns-2': steps[currentStep].questions[currentQuestion].primary.columns === '2',
                                                'question-container__steps-body-columns-3': steps[currentStep].questions[currentQuestion].primary.columns === '3',
                                                'question-container__steps-body-relation-2080': steps[currentStep].questions[currentQuestion].primary.columns === '2' && steps[currentStep].questions[currentQuestion].primary.relationship_columns === '20-80',
                                                'question-container__steps-body-relation-3070': steps[currentStep].questions[currentQuestion].primary.columns === '2' && steps[currentStep].questions[currentQuestion].primary.relationship_columns === '30-70',
                                                'question-container__steps-body-relation-4060': steps[currentStep].questions[currentQuestion].primary.columns === '2' && steps[currentStep].questions[currentQuestion].primary.relationship_columns === '40-60',
                                                'question-container__steps-body-relation-5050': steps[currentStep].questions[currentQuestion].primary.columns === '2' && steps[currentStep].questions[currentQuestion].primary.relationship_columns === '50-50',
                                                'question-container__steps-body-relation-6040': steps[currentStep].questions[currentQuestion].primary.columns === '2' && steps[currentStep].questions[currentQuestion].primary.relationship_columns === '60-40',
                                                'question-container__steps-body-relation-7030': steps[currentStep].questions[currentQuestion].primary.columns === '2' && steps[currentStep].questions[currentQuestion].primary.relationship_columns === '70-30',
                                                'question-container__steps-body-relation-8020': steps[currentStep].questions[currentQuestion].primary.columns === '2' && steps[currentStep].questions[currentQuestion].primary.relationship_columns === '80-20',
                                            }
                                        )
                                    }
                                >
                                    <div className='field-group-container'>
                                        <div className='question-container__steps-content'>
                                            <div>
                                                {getCurrentQuestions()?.primary?.barrainfosuperior === "Si" && (<QuoteNumberTitle />)}
                                                {!loading && steps[currentStep]?.questions[currentQuestion]?.primary?.title[0]?.text && (
                                                    <h2 className='question-container__steps-title'>
                                                        {steps[currentStep].questions[currentQuestion].primary.title[0].text}
                                                    </h2>
                                                )}
                                                {!loading && steps[currentStep]?.questions[currentQuestion]?.primary?.description[0]?.text && (
                                                    <div className='question-container__steps-description'>
                                                        {steps[currentStep].questions[currentQuestion]?.primary?.collapse_description ?
                                                            <Collapse >
                                                                <Collapse.Panel header={steps[currentStep].questions[currentQuestion].primary.description[0].text} key="1">
                                                                    {!loading && steps[currentStep]?.questions[currentQuestion]?.primary?.collapsable_text[0]?.text && (
                                                                        <RichText render={steps[currentStep].questions[currentQuestion].primary.collapsable_text} />
                                                                    )}
                                                                </Collapse.Panel>
                                                            </Collapse>
                                                            : <RichText render={steps[currentStep].questions[currentQuestion].primary.description} />
                                                        }
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='field-group'>
                                            {loading && (<div className='field-group-mask'></div>)}
                                            {getCurrentQuestions().newItems.map((field, index) => {

                                                let showField = false;
                                                const fieldType = field && field.customClass ? field.customClass : field && field.type ? field.type : '';
                                                const totalFields = steps[currentStep] && steps[currentStep].questions[currentQuestion].newItems.length;

                                                setReturnButton(returnButton ? getCurrentQuestions().primary.returnbutton === 'Si' : returnButton)

                                                const fieldValue = field && field.conditional ? formResponses.find(value => value.key === field.conditional.when) : {};
                                                showField = fieldValue && Object.keys(fieldValue).length > 0 && fieldValue.value ?
                                                    (fieldValue.value).toString() === field.conditional.eq ? field.conditional.show : false : !(field && field.conditional);

                                                disabledFields[field && field.key] = disabledFields[field && field.key] ? disabledFields[field && field.key] :
                                                    field && field.disabled ? field && field.disabled : false;

                                                if (!showField && totalFields > 1) {
                                                    showField = true;
                                                    const key = field && field.key;
                                                    hiddenFields[key] = hiddenFields[key] === undefined ? true : hiddenFields[key];
                                                }

                                                if (field && field.type === 'hidden' && formResponses.findIndex(x => x.key === field.key) == -1) {
                                                    field.value = field.defaultValue;
                                                    formResponses.push(field);
                                                }

                                                if (showField) {
                                                    const key = `field-step-${currentStep}-${index}`;
                                                    return fields(fieldType, field, form, key, getCurrentQuestions())
                                                } else {
                                                    const currentQuestionValue = isGoToBack ?
                                                        currentQuestion > 0 ? currentQuestion - 1 : currentQuestion
                                                        : currentQuestion < numberQuestionsStep - 1 ? currentQuestion + 1 : 0;

                                                    const currentStepValue = isGoToBack ? currentQuestion == 0 ? currentStep - 1 : currentStep
                                                        : currentQuestion == numberQuestionsStep - 1 ? currentStep + 1 : currentStep;

                                                    setFormStatus({
                                                        steps,
                                                        currentStep: currentStepValue,
                                                        currentQuestion: currentQuestionValue,
                                                        numberQuestionsStep: steps[currentStepValue]?.questions.length,
                                                        isGoToBack: false
                                                    });
                                                }
                                            })}
                                        </div>
                                    </div>
                                    {getCurrentQuestions().primary.sidebar !== "No" && (<div className='sidebar-container'>
                                        {getCurrentQuestions().primary.sidebar === "Resumen" && (
                                            <SidebarResume service={getCurrentQuestions().primary.sidebar_service} form={form} />
                                        )}
                                        {getCurrentQuestions().primary.sidebar === "Contenido" && (
                                            <div className='sidebar-resume sidebar-resume-default'>
                                                <img
                                                    src={getCurrentQuestions().primary.sidebarimg.url}
                                                    alt={getCurrentQuestions().primary.sidebarimg?.alt}
                                                />
                                                <div className="title-sidebar">{getCurrentQuestions().primary.sidebarimg.alt}</div>
                                            </div>

                                        )}
                                        <div className='sidebar-container-btn'>
                                            {continueBtn()}
                                        </div>
                                    </div>)}
                                </Form>
                            )}

                            {steps[currentStep]?.questions[currentQuestion]?.primary?.enable_email === 'Si' && (
                                <div className='question-container__steps-support'>
                                    <RichText
                                        render={info.data.email_info}
                                    />
                                </div>
                            )}
                        </div>)}
                    {getCurrentQuestions()?.primary?.sidebar === "No" && continueBtn()}
                </div>
            </div>
        </GoogleReCaptchaProvider>
        )   
            
}
